/**
 * Loading / empty / error placeholders.
 */

import type { ReactNode } from "react";

export function LoadingState({ message = "Loading…" }: { message?: string }) {
  return (
    <div className="flex items-center gap-2 px-4 py-8 text-sm text-foreground-secondary">
      <span className="inline-block h-2 w-2 animate-pulse rounded-full bg-accent" />
      {message}
    </div>
  );
}

export function EmptyState({
  title,
  description,
  action,
}: {
  title: string;
  description?: ReactNode;
  action?: ReactNode;
}) {
  return (
    <div className="flex flex-col items-center justify-center gap-2 px-4 py-10 text-center">
      <p className="text-sm font-medium text-foreground-primary">{title}</p>
      {description && (
        <p className="max-w-sm text-xs text-foreground-secondary">{description}</p>
      )}
      {action && <div className="pt-2">{action}</div>}
    </div>
  );
}

export function ErrorState({
  title = "Something went wrong",
  detail,
  action,
}: {
  title?: string;
  detail?: ReactNode;
  action?: ReactNode;
}) {
  return (
    <div className="flex flex-col items-center justify-center gap-2 px-4 py-8 text-center">
      <p className="text-sm font-medium text-danger">{title}</p>
      {detail && (
        <p className="max-w-sm text-xs text-foreground-secondary">{detail}</p>
      )}
      {action && <div className="pt-2">{action}</div>}
    </div>
  );
}
